import { UpdateVerificationFlowBody, VerificationFlow } from "@ory/client";
import { UserAuthCard } from "@ory/elements";
import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router";
import { routes } from "@routes";
import { ory } from "@services/authentication";
import { ErrorData, handleError } from "@pages/authentication/error";
import { Authentication } from "@pages/authentication/Authentication";
import { Spinner } from "@thetreep/ui";

export function Verification() {
  const [flow, setFlow] = useState<VerificationFlow | null>(null);
  const [searchParams, setSearchParams] = useSearchParams();
  const navigate = useNavigate();
  const returnTo = window.location.origin;

  const errorHandler: (error: ErrorData) => unknown = handleError(
    (flowId: string) => getFlow(flowId),
    setFlow,
    routes.LOGIN,
    true,
    navigate,
  );

  const getFlow = async (flowId: string) => {
    try {
      const res = await ory().getVerificationFlow({ id: flowId });
      setFlow(res.data);
    } catch (e) {
      errorHandler(e as ErrorData);
    }
  };

  const createFlow = async () => {
    try {
      const res = await ory().createBrowserVerificationFlow({
        ...(returnTo && { returnTo }),
      });

      setSearchParams({ flow: res.data.id });
      setFlow(res.data);
    } catch (error) {
      errorHandler(error as ErrorData);
    }
  };

  const submitFlow = async (body: UpdateVerificationFlowBody) => {
    if (!flow) {
      navigate(routes.REGISTRATION, { replace: true });
      return;
    }

    try {
      const res = await ory().updateVerificationFlow({
        flow: flow.id,
        updateVerificationFlowBody: body,
      });
      setFlow(res.data);
    } catch (error) {
      errorHandler(error as ErrorData);
    }
  };

  useEffect(() => {
    const flowId = searchParams.get("flow");
    if (flowId) {
      getFlow(flowId);
      return;
    }
    // oxlint-disable-next-line react-hooks/set-state-in-effect
    createFlow();
  }, [searchParams]);

  if (!flow) {
    return (
      <div className="w-full h-full flex items-center justify-center">
        <Spinner />
      </div>
    );
  }

  return (
    <Authentication>
      <UserAuthCard
        flowType="verification"
        flow={flow}
        className="authCard"
        additionalProps={{
          signupURL: {
            handler: () => {
              navigate({ pathname: routes.REGISTRATION }, { replace: true });
            },
          },
        }}
        onSubmit={({ body }) => submitFlow(body as UpdateVerificationFlowBody)}
      />
    </Authentication>
  );
}
